export default "__VITE_ASSET__HGWdRRjI__"